<ng-container *ngIf="!productDetails()">
    <div class="fixed inset-0 bg-white opacity-50 flex items-center justify-center z-50">
        <p-progressSpinner styleClass="w-16 h-16" strokeWidth="4" animationDuration=".5s"></p-progressSpinner>
    </div>
</ng-container>